/* ================ Input Range ================ */
// const minValue = document.getElementById("min-value"),
//       maxValue = document.getElementById("max-value"),
//       minSlider = document.getElementById("min-slider"),
//       maxSlider = document.getElementById("max-slider"),
//       progress = document.querySelector(".progress");
// const gap = 5,
//       minRange = +minSlider.min,
//       maxRange = +minSlider.max;
// const fillColor = () => {
//   progress.style.left = `${(minSlider.value / maxRange) * 100}%`;
//   progress.style.right = `${100 - (maxSlider.value / maxRange) * 100}%`;
// };
// const syncSlider = (slider, valueInput, otherSlider, isMin) => {
//   let val = +slider.value;
//   val = isMin ? Math.min(val, otherSlider.value - gap) : Math.max(val, +otherSlider.value + gap);
//   slider.value = val;
//   valueInput.value = val;
//   fillColor();
// };
// const syncInput = (input, slider, otherSlider, isMin) => {
//   let val = parseInt(input.value);
//   val = isNaN(val) ? (isMin ? minRange : maxRange) : val;
//   if (isMin) {
//     val = Math.max(minRange, Math.min(val, otherSlider.value - gap));
//   } else {
//     val = Math.min(maxRange, Math.max(val, +otherSlider.value + gap));
//   }
//   slider.value = input.value = val;
//   fillColor();
// };
// window.addEventListener("load", fillColor);
// minSlider.addEventListener("input", () => syncSlider(minSlider, minValue, maxSlider, true));
// maxSlider.addEventListener("input", () => syncSlider(maxSlider, maxValue, minSlider, false));

// [minValue, maxValue].forEach((input, i) => {
//   input.addEventListener("blur", () => syncInput(input, [minSlider, maxSlider][i], [maxSlider, minSlider][i], i === 0));
//   input.addEventListener("keydown", (e) => {
//     if (e.key === "Enter") {
//       syncInput(input, [minSlider, maxSlider][i], [maxSlider, minSlider][i], i === 0);
//       input.blur();
//     }
//   });
// });

function initSliders(){
  /* ================ Best Seller slider ================ */
  var BestSeller = new Swiper(".best_seller_slider", {
    slidesPerView: 1.5,
    spaceBetween: 20,
    autoplay: {
      delay: 3000,
    },
    breakpoints: {
      450: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      1025: {
        slidesPerView: 4,
      },
    },
  });

  /* ================ Product slider ================ */
  var swiper = new Swiper(".product_image_navigator", {
    spaceBetween: 20,
    loop: false,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
  });

  var swiper2 = new Swiper(".product_image_slider", {
    spaceBetween: 0,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    simulateTouch: false,
    thumbs: {
      swiper: swiper,
    }
  });

  var ProductDetailsImage = new Swiper(".product_detail_image_slider", {
    slidesPerView: 1.3,
    spaceBetween: 20,
    autoplay: {
      delay: 3000,
    },
    breakpoints: {
      576: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
  });

  initPlayStoreSwiper();
}

var playStoreSwiperMq = window.matchMedia('(max-width: 767px)');

function initPlayStoreSwiper() {
  document.querySelectorAll('.play-store-swiper').forEach(function (el) {
    if (el.swiper) {
      el.swiper.destroy(true, true);
    }
  });

  if (!playStoreSwiperMq.matches) return;

  document.querySelectorAll('.play-store-swiper').forEach(function (el) {
    new Swiper(el, {
      slidesPerView: 2.5,
      spaceBetween: 12,
      watchOverflow: true,
    });
  });
}

if (!window.playStoreSwiperResizeBound) {
  window.playStoreSwiperResizeBound = true;
  playStoreSwiperMq.addEventListener('change', initPlayStoreSwiper);
}

initSliders();
if (Shopify.designMode) {
  $(document).on('shopify:section:load shopify:section:unload shopify:block:select shopify:block:deselect shopify:section:reorder shopify:section:select shopify:section:deselect', function() {
    initSliders();
    initPlayStoreSwiper();
    initAnnounceBarHover();
  });
}

/* ================ Announcement bar: slow scroll + smooth pause on hover ================ */
function initAnnounceBarHover() {
  var EASE_MS = 600;

  document.querySelectorAll('.announcebar').forEach(function (bar) {
    if (bar.dataset.announceHoverInit === 'true') return;

    var wrap = bar.querySelector('.announcebar_wrp');
    if (!wrap) return;

    bar.dataset.announceHoverInit = 'true';

    var pauseFrame = null;
    var resumeFrame = null;

    function cancelFrames() {
      if (pauseFrame) cancelAnimationFrame(pauseFrame);
      if (resumeFrame) cancelAnimationFrame(resumeFrame);
      pauseFrame = resumeFrame = null;
    }

    function getMarqueeAnim() {
      if (!wrap.getAnimations) return null;
      return wrap.getAnimations().find(function (a) {
        return a.animationName === 'marquee';
      });
    }

    function smoothPause() {
      var anim = getMarqueeAnim();
      if (!anim || anim.playState === 'paused') return;

      cancelFrames();

      var startRate = anim.playbackRate || 1;
      var start = performance.now();

      function tick(now) {
        var t = Math.min(1, (now - start) / EASE_MS);
        var eased = 1 - Math.pow(1 - t, 2);
        anim.playbackRate = Math.max(0, startRate * (1 - eased));

        if (t < 1) {
          pauseFrame = requestAnimationFrame(tick);
        } else {
          anim.playbackRate = 0;
          anim.pause();
        }
      }

      pauseFrame = requestAnimationFrame(tick);
    }

    function smoothResume() {
      var anim = getMarqueeAnim();
      if (!anim) return;

      cancelFrames();

      if (anim.playState === 'paused') {
        anim.playbackRate = 0;
        anim.play();
      }

      var start = performance.now();

      function tick(now) {
        var t = Math.min(1, (now - start) / EASE_MS);
        var eased = Math.pow(t, 2);
        anim.playbackRate = eased;

        if (t < 1) {
          resumeFrame = requestAnimationFrame(tick);
        } else {
          anim.playbackRate = 1;
        }
      }

      resumeFrame = requestAnimationFrame(tick);
    }

    bar.addEventListener('mouseenter', smoothPause);
    bar.addEventListener('mouseleave', smoothResume);
    bar.addEventListener('focusin', smoothPause);
    bar.addEventListener('focusout', function (e) {
      if (!bar.contains(e.relatedTarget)) smoothResume();
    });
  });
}

/* ================ Header Height ================ */
var footerHeight = $('footer').innerHeight();
var headerHeight = $('header').innerHeight();
function Headerspace() {
  $("body").css("--headerHeight", `${headerHeight}px`);
}
Headerspace();
function Footerspace() {
  $("body").css("--footerHeight", `${footerHeight}px`);
}
Footerspace();

function getPageAnchorIds() {
  return new Set(
    Array.from(document.querySelectorAll('[id]'))
      .map((el) => el.id)
      .filter(Boolean)
  );
}

function fixMissingAnchorLinks(root) {
  const scope = root || document;
  const pageIds = getPageAnchorIds();

  scope.querySelectorAll('a[href^="#"]').forEach((link) => {
    const href = link.getAttribute('href');
    if (!href) return;

    const isJudgemeProductLink =
      link.classList.contains('jdgm-carousel-item__product') ||
      link.closest('.jdgm-carousel-item__product');

    if (href === '#') {
      if (isJudgemeProductLink) {
        link.removeAttribute('href');
        link.setAttribute('role', 'presentation');
        link.setAttribute('tabindex', '-1');
      }
      return;
    }

    const targetId = decodeURIComponent(href.slice(1).split('?')[0]);
    if (!targetId || pageIds.has(targetId)) return;

    link.removeAttribute('href');
    if (!link.hasAttribute('role')) {
      link.setAttribute(
        'role',
        link.classList.toString().includes('swym') || link.getAttribute('onclick') ? 'button' : 'presentation'
      );
    }
  });
}

window.fixMissingAnchorLinks = fixMissingAnchorLinks;

function fixInstafeedProfileLinks(root) {
  const scope = root || document;
  const labelTemplate = window.translate?.instagram_profile || 'View {{ username }} on Instagram';

  scope.querySelectorAll('a.vibe-profile:not([aria-label])').forEach((link) => {
    const match = link.href.match(/instagram\.com\/([^/?#]+)/i);
    const username = match ? match[1] : '';
    const label = labelTemplate.replace('{{ username }}', username || 'profile');

    link.setAttribute('aria-label', label);

    if (link.target === '_blank' && !link.getAttribute('rel')) {
      link.setAttribute('rel', 'noopener noreferrer');
    }
  });
}

window.fixInstafeedProfileLinks = fixInstafeedProfileLinks;

function initMissingAnchorFix() {
  fixMissingAnchorLinks();
  fixInstafeedProfileLinks();

  if (typeof MutationObserver === 'undefined') return;

  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      fixMissingAnchorLinks();
      fixInstafeedProfileLinks();
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

$(document).ready(function () {
  initAnnounceBarHover();
  initMissingAnchorFix();
  /* ================ On Scroll Sticky Header ================ */
  $(window).on("scroll", function () {
    var announcebarHeight = $(".announcebar").outerHeight();
    var reviewHeight = $(".header_reviewbar").outerHeight();
    if ($(window).scrollTop() > announcebarHeight + reviewHeight - 1 ) {
      $(".header_main_wrapper").addClass("sticky");
    } else {
      $(".header_main_wrapper").removeClass("sticky");
    }
  });


  /* ================ Search Modal Header ================ */
// $(document).ready(function() {
//   // Open and close search modal on search icon click
//   $('.serach-icon').click(function(e) {
//     e.preventDefault(); // Prevent default anchor action
//     $('.search-modal').toggleClass('open'); // Toggle 'open' class to show/hide modal
//   });

//   // Close the search modal if user clicks outside the modal
//   $(document).click(function(e) {
//     if (!$(e.target).closest('.search-modal, .serach-icon').length) {
//       $('.search-modal').removeClass('open'); // Close the modal
//     }
//   });

//   // Prevent closing modal when clicking inside the modal
//   $('.search-modal').click(function(e) {
//     e.stopPropagation(); // Prevent click from propagating to document
//   });
// });

  
  /* ================ Drawer accessibility ================ */
  var _lastDrawerTrigger = null;

  function getDrawerTriggers(drawerId) {
    return drawerId
      ? $('[aria-controls="' + drawerId + '"]').filter('[aria-expanded]')
      : $();
  }

  function anyDrawerActive() {
    return $('.menu_drawer.active, .filter_block.active, .main_cart_drawer.active, .collection-filters-sidebar.active').length > 0;
  }

  window.openDrawer = function (drawerSelector, trigger) {
    var $drawer = $(drawerSelector).first();
    if (!$drawer.length || $drawer.hasClass('active')) return;

    _lastDrawerTrigger = trigger ? $(trigger) : _lastDrawerTrigger;
    var drawerId = $drawer.attr('id');

    $('.overlay').addClass('active').attr('aria-hidden', 'false');
    $drawer.addClass('active').attr('aria-hidden', 'false');

    if (drawerId) {
      getDrawerTriggers(drawerId).attr('aria-expanded', 'true');
    }

    if ($drawer.hasClass('collection-filters-sidebar')) {
      document.body.style.overflow = 'hidden';
      $drawer.closest('[id^="shopify-section-"]').find('.filter-overlay').addClass('active').attr('aria-hidden', 'false');
    }

    var $focusTarget = $drawer.find('.menu_close, .filter_close, .cart-close-btn, .filter-close').first();
    if ($focusTarget.length) {
      $focusTarget.focus();
    }
  };

  window.closeDrawer = function (drawerSelector, returnFocus) {
    var $drawer = $(drawerSelector).first();
    if (!$drawer.length) return;

    var drawerId = $drawer.attr('id');
    $drawer.removeClass('active').attr('aria-hidden', 'true');

    if (drawerId) {
      getDrawerTriggers(drawerId).attr('aria-expanded', 'false');
    }

    if ($drawer.hasClass('collection-filters-sidebar')) {
      document.body.style.overflow = '';
      $drawer.closest('[id^="shopify-section-"]').find('.filter-overlay').removeClass('active').attr('aria-hidden', 'true');
    }

    if (!anyDrawerActive()) {
      $('.overlay').removeClass('active').attr('aria-hidden', 'true');
    }

    if (returnFocus !== false && _lastDrawerTrigger && _lastDrawerTrigger.length) {
      _lastDrawerTrigger.focus();
      _lastDrawerTrigger = null;
    }
  };

  function closeActiveDrawer(returnFocus) {
    var $active = $('.menu_drawer.active, .filter_block.active, .main_cart_drawer.active, .collection-filters-sidebar.active').first();
    if ($active.length) {
      var selector = $active.attr('id') ? '#' + $active.attr('id') : null;
      if (selector) {
        window.closeDrawer(selector, returnFocus);
      } else {
        $active.removeClass('active').attr('aria-hidden', 'true');
        if (!anyDrawerActive()) {
          $('.overlay').removeClass('active').attr('aria-hidden', 'true');
        }
      }
    }
  }

  /* ================ Accordion ================ */
  function getAccordionPanel($button) {
    var panelId = $button.attr('aria-controls');
    return panelId ? $('#' + panelId) : $button.closest('.faq_block').find('.faq_content').first();
  }

  function setAccordionState($button, expanded, animate) {
    var $panel = getAccordionPanel($button);
    if (!$panel.length) return;

    $button.attr('aria-expanded', expanded ? 'true' : 'false');
    $button.toggleClass('active', expanded);

    if (expanded) {
      if (animate) {
        $panel.prop('hidden', false).hide().slideDown(function () {
          $panel.prop('hidden', false);
        });
      } else {
        $panel.prop('hidden', false).show();
      }
    } else {
      if (animate) {
        $panel.slideUp(function () {
          $panel.prop('hidden', true);
        });
      } else {
        $panel.hide().prop('hidden', true);
      }
    }
  }

  function closeAccordionGroup($container, exceptButton) {
    $container.find('button.faq_header').each(function () {
      if (exceptButton && this === exceptButton[0]) return;
      setAccordionState($(this), false, true);
    });
  }

  window.initFaqAccordions = function (root) {
    var $scope = root ? $(root) : $(document);
    $scope.find('button.faq_header').each(function () {
      var $button = $(this);
      var expanded = $button.attr('aria-expanded') === 'true';
      setAccordionState($button, expanded, false);
    });
  };

  window.initFaqAccordions();

  $('body').on('click', 'button.faq_header', function (e) {
    e.preventDefault();
    var $button = $(this);
    var isExpanded = $button.attr('aria-expanded') === 'true';
    var $accordionGroup = $button.closest('.filter_faq, .faq_wrapper, .faq_section');

    if (!$button.hasClass('submenu-toggle') && $accordionGroup.length) {
      closeAccordionGroup($accordionGroup, isExpanded ? null : $button);
    }

    setAccordionState($button, !isExpanded, true);
  });

  /* ================ Mobile menu ================ */
  $('body').on('click', '.menu_open', function (e) {
    e.preventDefault();
    _lastDrawerTrigger = $(this);
    window.openDrawer('#MobileMenu-drawer', this);
  });
  $('body').on('click', '.menu_close', function (e) {
    e.preventDefault();
    window.closeDrawer('#MobileMenu-drawer');
  });

  /* ================ Filter sidebar ================ */
  $('body').on('click', '.filter_open', function (e) {
    e.preventDefault();
    _lastDrawerTrigger = $(this);
    var drawerId = $(this).attr('aria-controls');
    window.openDrawer(drawerId ? '#' + drawerId : '.filter_block.active, .filter_block', this);
  });
  $('body').on('click', '.filter_close', function (e) {
    e.preventDefault();
    var drawerId = $(this).attr('aria-controls');
    window.closeDrawer(drawerId ? '#' + drawerId : '.filter_block');
  });

  /* ================ Cart drawer ================ */
  $('body').on('click', '.cart-drawer-enable', function (e) {
    e.preventDefault();
    _lastDrawerTrigger = $(this);
    window.openDrawer('#CartDrawer', this);
  });
  $('body').on('click', '.cart-close-btn', function (e) {
    e.preventDefault();
    window.closeDrawer('#CartDrawer');
  });

  /* ================ Overlay + Escape ================ */
  $('body').on('click', '.overlay.active', function () {
    closeActiveDrawer(true);
  });

  $(document).on('keydown', function (e) {
    if (e.key === 'Escape') {
      closeActiveDrawer(true);
    }
  });

  /* ================ Product page qty box ================ */
  $('body').on('click', '.add_to_cart_wrapper .qty_inc', function(e){
    e.preventDefault();
    var input = $(this).parent().find('input');
    var ip = parseInt(input.val());
    ip = $(this).hasClass('plus') ? ip+1 : ip-1;
    if (ip < 1) ip = 1;
    input.val(ip);
  });

  /* ================ Cart update / change ================ */
  function changeCartData(section_id, open_cart_drawer = false) {
    $.get(
      window.routes.cart_url + "?section_id=" + section_id + "&t=" + Math.random(),
      function (data) {
        $("[data-cart-total]").html($(data).find("[data-cart-total]").html());
        $("[data-cart-item]").html($(data).find("[data-cart-item]").html());
        $(".side-cart-progress-bar").html($(data).find(".side-cart-progress-bar").html());
        console.log("Cart Updated...");
        $('[data-cart-item]').removeClass('is-loading');
      }
    );
  }
  function activeCartCount() {
    jQuery.getJSON(window.routes.cart_url  + "?t=" + Math.random(), function (cart) {
      $('.cart_counter').html(cart.item_count);
      if (cart.item_count == 0) {
        $("[data-cart-wrapper]").addClass("cart--empty-true");
      } else {
        $("[data-cart-wrapper]").removeClass("cart--empty-true");
      }
    });
  }

  function updateCart(_this, $parent, itemData, section_id, is_discount = false, discountCodeValue = null, existingDiscounts = null, discountCodeInput = null) {
    $(".stock-errror").remove();
    $(".cart-discount__error-text").empty().hide();
    $.ajax({
      type: "POST",
      url: window.routes.cart_update_url + "?t=" + Math.random(),
      dataType: "json",
      data: itemData,
      async: false,
      success: function (data) {
        if (is_discount) {
          handleDiscountResponse(data, discountCodeValue, existingDiscounts, discountCodeInput);
        }
        changeCartData(section_id, false);
        activeCartCount();
        setTimeout(function () {
          $parent.find("button, select").removeAttr("disabled");
          $('[data-cart-item]').removeClass('is-loading');
        }, 2000);
        if (data.item_count == 0) localStorage.removeItem('cart-reserved-time');
      },
      error: function (response) {
        $parent.find("button, select").removeAttr("disabled");
        $('[data-cart-item]').removeClass('is-loading');

        _this.parents("[data-line-qty]").length > 0 
        ?  _this.parents("[data-line-qty]").append('<p class="stock-errror error-message">' + response.responseJSON.errors + "</p>") 
        : $parent.find("[data-cart-item]").append('<p class="stock-errror error-message">' + response.responseJSON.errors + "</p>");

        setTimeout(function () {
          changeCartData(section_id, false);
          activeCartCount();
          $(".stock-errror").remove();
          $(".cart-discount__error-text").empty().hide();
        }, 2000);
      },
    });
  }

  function addToCart(_this, formData, _this_text, section_id){
     $.ajax({
      type: "POST",
      url: window.routes.cart_add_url + "?t=" + Math.random(),
      data: formData,
      dataType: "json",
      async: false,
      error: function (jqXHR, ajaxOptions, thrownError) {
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.errors);
        if (response.errors.indexOf('added to your cart') > -1 || response.errors.indexOf('disponibilité') > -1 || response.errors.indexOf('beschikbaarheid') > -1) {
          changeCartData(section_id, true);
          activeCartCount();
        }
        setTimeout(function () {
          _this.removeAttr("disabled").html(_this_text);
        }, 500);
      },
    }).done(function (data) {
      _this.html(window.translate.added_cart);
      changeCartData(section_id, true);
      activeCartCount();
      // CART TIMER ENABLE
      localStorage.setItem('cart-reserved-time', Date.now());
      window.is_cart_cleared = false;
      if ($('.cart-timer').length > 0) {
        window.clearInterval(window.startTimerInterval);
        window.startTimer(window.timerMinutes / 1000,  $('.cart-timer'), localStorage.getItem('cart-reserved-time'));
      }
      // CART TIMER ENABLE
      setTimeout(function () {
        _this.removeAttr("disabled").html(_this_text);
        window.openDrawer('#CartDrawer', _this[0]);
      }, 1000);
    });
  }
  
  $("body").on("click", ".cart_qty", function (e) {
    $(".stock-errror").remove();
    var _this = $(this),
      form = _this.closest('form'),
      $parent = $(this).parents('[data-cart-item]'),
      error = "",
      input = $(this).parent().find("input"),
      min = input.data("min"),
      max = input.attr("max"),
      step = input.attr("step"),
      section_id = input.data("section-id"),
      input_val = parseInt(input.val());

    error =
      input_val < min
        ? `This item has a minimum of ${min}`
        : input_val > parseInt(max)
        ? `This item has a maximum of ${max}`
        : input_val % parseInt(step) !== 0
        ? `You can only add this item in increments of ${step}`
        : "";

    input_val +=
      $(this).hasClass("qty-plus")
        ? parseInt(min) > parseInt(step)
          ? 1
          : 1
        : -1;

    if (error != '') {
      $(this)
        .parents("[data-line-qty]")
        .append('<p class="stock-errror error-message">' + error + "</p>");
        return;
    }

    $parent.find("button, select").attr("disabled", "disabled");
    $('[data-cart-item]').addClass('is-loading');

    input.val(input_val);
    var key = $parent.find('[name="updates[]"]').data("id"), 
        itemData = form.serialize();
    updateCart($(this), $parent, itemData, section_id);
  });

  let debounceTimer;
  $('body').on('change','[name="updates[]"]',function(e){
      e.preventDefault();
      var q = $(this).val(), input = $(this),
      form = input.closest('form'),
      $parent = $(this).parents('[data-cart-item]'),
      error = "",
      min = input.data("min"),
      max = input.attr("max"),
      step = input.attr("step"),
      section_id = input.data("section-id");
    
      if(q != ''){
        clearTimeout(debounceTimer); 
        debounceTimer = setTimeout(async function () {
          $(".stock-errror").remove();

          var input_val = parseInt(input.val());

          error =
            input_val < min
              ? `This item has a minimum of ${min}`
              : input_val > parseInt(max)
              ? `This item has a maximum of ${max}`
              : input_val % parseInt(step) !== 0
              ? `You can only add this item in increments of ${step}`
              : "";

          if (error != '') {
            input
            .parents("[data-line-qty]")
            .append('<p class="stock-errror error-message">' + error + "</p>");
            return;
          }   

          $parent.find("button, select").attr("disabled", "disabled");
          $('[data-cart-item]').addClass('is-loading');

          var key = $parent.find('[name="updates[]"]').data("id"), 
              itemData = form.serialize();
              // itemData = 'updates['+parseInt(key)+']='+input_val;
          updateCart(input, $parent, itemData, section_id);
        }, 1000);
      }
  });

  $("body").on("click", "[data-cart-delete]", function (e) {
    e.preventDefault();

    var $parent = $(this).parents('[data-item-list]'),
        key = $parent.find('[name="updates[]"]').data("id"),
        section_id = $parent.find('[name="updates[]"]').data("section-id"),
        itemData = 'updates['+parseInt(key)+']=0';
    
    $parent.find("button, select").attr("disabled", "disabled");
    $('[data-cart-item]').addClass('is-loading');
    updateCart($(this), $parent, itemData, section_id);
  });

  /* ================ Cart Timer ================ */
  window.startTimer = function(duration, display, getLSTime) {
    var getTime = parseInt(getLSTime), start = Date.now(), diff, minutes, seconds;
    function timer() {
        diff = duration - (((Date.now() - getTime) / 1000) | 0);
  
        minutes = (diff / 60) | 0;
        seconds = (diff % 60) | 0;
  
        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;
  
        display.find('#minutes').text(minutes);
        display.find('#seconds').text(seconds);
  
        if (diff <= 0) {
          // display.hide();
          clearCart(false);
        }
    };
    timer();
    window.startTimerInterval = setInterval(timer, 1000);
  }

  // Set the cookie to the new time        
  function clearCart(setC = false) {
    if (window.is_cart_cleared) return;

    Shopify.clear(function(c){
      window.is_cart_cleared = true;
      console.log('Cart Cleared...');
      localStorage.removeItem('cart-reserved-time');
      location.reload();
    });
  }
  
  function clearCookiewithoutLoad(getLSTime) {
    console.log('Current time greater than localstorage time: ', Date.now() > getLSTime);
    if (parseInt(Date.now()) > getLSTime && getLSTime != null) {
      clearCart(false);
    }
  }
  
  if ($('.cart-timer').length > 0) {
    window.startTimer(window.timerMinutes / 1000,  $('.cart-timer'), localStorage.getItem('cart-reserved-time'));
  }

  var localStorage_time = localStorage.getItem('cart-reserved-time'),
      clear_localstorage = localStorage.getItem('clear-cart-reserved');
  if (localStorage_time != null && localStorage_time != undefined) {
    console.log('LocalStorage Get: ', localStorage_time);
    var getLSTime = parseInt(localStorage_time) + window.timerMinutes;
    clearCookiewithoutLoad(getLSTime);
  } else if (localStorage_time == null && clear_localstorage == null) {
      localStorage.setItem('clear-cart-reserved', 1);
      clearCart(false);
  }

  /* ================ Product Add to cart ================ */
  $("body").on("click", "[data-add-to-cart]", function (e) {
    e.preventDefault();
    var _this = $(this),
      _this_text = _this.html(),
      form = $(this).closest("form"),
      formData = form.serializeArray(),
      section_id = _this.data("section-id");
    
      const quantityItem = formData.find(item => item.name === "quantity");
      if (quantityItem && parseInt(quantityItem.value) <= 0) {
        alert(window.translate.quantity_error);
        setTimeout(function () {
          _this.removeAttr("disabled").html(_this_text);
        }, 1000);
        return false; 
      }

      _this.attr("disabled", "disabled").html(window.translate.adding);  
      
      addToCart(_this, formData, _this_text, section_id);
  });

  /* ================ FAQ Page ================ */
  $('.tab_wrapper').each(function () {
    var $wrapper = $(this);
    var $buttons = $wrapper.find('.faq_tab_link .tab_link');
    var $contents = $wrapper.find('.faq_tab_content .tab_content');
    $buttons.first().addClass('active');
    $contents.removeClass('active').first().addClass('active');
    $buttons.on('click', function () {
      var tabId = $(this).data('tab');
      $buttons.removeClass('active');
      $(this).addClass('active');
      $contents.removeClass('active');
      $wrapper.find('.tab_content#' + tabId).addClass('active');
    });
  });

  /* ================ shipping page  ================ */
   $('body').on('click','.footer_menu_list li',function(){
    setTimeout(function(){
      shipping_tab();
    },500);
    
  });
function shipping_tab(){
  var hash = window.location.hash;

  if (hash && hash.startsWith('#tab-')) {
    var $button = $(hash);
    if ($button.length && $button.hasClass('tab_link')) {
      $button.trigger('click');
      // Scroll to the tab section if needed
      $('html, body').animate({
        scrollTop: $button.offset().top - 100
      }, 500);
    }
  }
}
 shipping_tab();

  /* ================ Contact Form ================ */
  $('body').on('click','.contact_send', function(e){
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    var form = $(this).closest('.form_wrapper');
    var x = true;
    form.find('.err-msg').remove();
  
    var name = form.find('#Name'),
        msg = form.find('#Message'),
        email = form.find('#Email'),
        phone = form.find('#Phone');
  
    if(name.val().trim() == ''){
      var message = window.translate.mess_error;
      name.parent().append('<p class="err-msg">'+message+'</p>');
      x = false;
    } else {
      name.parent().find('.err-msg').remove();
    }
  
    if(msg.val().trim() == ''){
      var message = window.translate.mess_error;
      msg.parent().append('<p class="err-msg">'+message+'</p>');
      x = false;
    } else {
      msg.parent().find('.err-msg').remove();
    }
  
    if(email.val().trim() == '' || !regex.test(email.val())) {
      var message = window.translate.email_error;
      if(email.val() == ''){
        message = window.translate.mess_error;
      }
      email.parent().append('<p class="err-msg">'+message+'</p>');
      x = false;
      e.preventDefault();
    } else {
      email.parent().find('.err-msg').remove();
    }
  
    if(x==false) {
      return false;
    }
  });

  /* ================ Discount code box ================ */
  function handleDiscountError(type, message) {
      const cartDiscountError = $('.cart-discount__error-text');
      if (cartDiscountError.length) cartDiscountError.html(message).show();
      setTimeout(function () {
        $('[data-cart-item]').removeClass('is-loading');
        cartDiscountError.empty().hide();
      }, 5000);
  }

  function existingDiscountsArray() {
      const discountCodes = [];
      $('.cart-discount__pill').each((index, pill) => {
          if ($(pill).data('discount-code')) {
            discountCodes.push($(pill).data('discount-code'));
          }
      });
      return discountCodes;
  }

  function handleDiscountResponse(data, discountCodeValue, existingDiscounts, discountCodeInput) {
    const discount = data.discount_codes.find(d => d.code === discountCodeValue);
    discountCodeInput.val('');

    if (discount && !discount.applicable) {
        handleDiscountError('discount_code', window.translate.invalid_code);
        return;
    }

    const sectionId = $('[data-cart-wrapper]').data('section');
    const newHtml = data.sections[sectionId];

    const $newSection = $(newHtml);
    const $section = $newSection.find(`#shopify-section-${sectionId}`);
    const discountCodes = $section.find('.cart-discount__pill')
        .map(function() {
            return $(this).data('discountCode');
        })
        .get();

    if (discountCodes.length === existingDiscounts.length &&
        discountCodes.every(code => existingDiscounts.includes(code)) &&
        discount && discount.applicable) {
        
        const isShippingDiscount = data.discount_codes.some(d => d.code === discountCodeValue && d.type === 'shipping');
        if (isShippingDiscount) {
            handleDiscountError('shipping', window.translate.shipping_discount_error);
            return;
        }
    }

    console.log('Cart refreshed');
  } 

  $("body").on('click', '.discount_code', function (e) {
    e.preventDefault();

    const discountCodeInput = $('input[name="discount"]'),
          discountCodeValue = discountCodeInput.val().trim();

    if (!discountCodeValue) return;

    const existingDiscounts = existingDiscountsArray();
    if (existingDiscounts.includes(discountCodeValue)) return;

    $('.cart-discount__error-text').hide();

    const requestData = {
        discount: [...existingDiscounts, discountCodeValue].join(','),
        sections: 'main-cart',
        sections_url: window.location.pathname
    };

    $('[data-cart-wrapper]').find("button, select").attr("disabled", "disabled");
    $('[data-cart-item]').addClass('is-loading');
    var section_id = $('[data-cart-wrapper]').data('section');
    updateCart($(this), $('[data-cart-wrapper]'), requestData, section_id, true, discountCodeValue, existingDiscounts, discountCodeInput);
  });

  $("body").on('click', '.cart-discount__pill-remove', function(e) {
      const pill = $(this).parent('.cart-discount__pill');
      if (!pill.length) return;

      const discountCode = pill.data('discount-code');
      if (!discountCode) return;

      const existingDiscounts = existingDiscountsArray();
      const index = existingDiscounts.indexOf(discountCode);
      if (index === -1) return;

      existingDiscounts.splice(index, 1);

      const requestData = {
          discount: [...existingDiscounts].join(','),
          sections: 'main-cart',
          sections_url: window.location.pathname
      };

      $('[data-cart-wrapper]').find("button, select").attr("disabled", "disabled");
      $('[data-cart-item]').addClass('is-loading');
      var section_id = $('[data-cart-wrapper]').data('section');
      updateCart($(this), $('[data-cart-wrapper]'), requestData, section_id, false);
  });


  $('.secondary_menu li .serach-icon').click(function () {
    if ($(window).width() > 1025) {
      $('.search-modal').addClass('open');
      $('.search-modal').find('input[type="search"]').attr('aria-expanded', 'false');
    }
  });
  $('.search-modal .search-close-btn').click(function () {
    if ($(window).width() > 1025) {
      $('.search-modal').removeClass('open');
      $('.search-modal').find('input[type="search"]').attr('aria-expanded', 'false');
    }
  });
});